
define('core/buffer',["require", "exports", './buffer_core', './buffer_core_array', './buffer_core_arraybuffer', './buffer_core_imagedata', './string_util'], function(require, exports, buffer_core, buffer_core_array, buffer_core_arraybuffer, buffer_core_imagedata, string_util) {
    var BufferCorePreferences = [
        buffer_core_arraybuffer.BufferCoreArrayBuffer,
        buffer_core_imagedata.BufferCoreImageData,
        buffer_core_array.BufferCoreArray
    ];

    var PreferredBufferCore = (function () {
        var i, bci;
        for (i = 0; i < BufferCorePreferences.length; i++) {
            bci = BufferCorePreferences[i];
            if (bci.isAvailable())
                return bci;
        }

        throw new Error("This browser does not support any available BufferCore implementations.");
    })();

    

    

    var Buffer = (function () {
        function Buffer(arg1, arg2, arg3) {
            if (typeof arg2 === "undefined") { arg2 = 'utf8'; }
            this.offset = 0;
            var i;

            if (!(this instanceof Buffer)) {
                return new Buffer(arg1, arg2);
            }

            if (arg1 instanceof buffer_core.BufferCoreCommon) {
                this.data = arg1;
                var start = typeof arg2 === 'number' ? arg2 : 0;
                var end = typeof arg3 === 'number' ? arg3 : this.data.getLength();
                this.offset = start;
                this.length = end - start;
            } else if (typeof arg1 === 'number') {
                if (arg1 !== (arg1 >>> 0)) {
                    throw new TypeError('Buffer size must be a uint32.');
                }
                this.length = arg1;
                this.data = new PreferredBufferCore(arg1);
            } else if (typeof DataView !== 'undefined' && arg1 instanceof DataView) {
                this.data = new buffer_core_arraybuffer.BufferCoreArrayBuffer(arg1);
                this.length = arg1.byteLength;
            } else if (typeof ArrayBuffer !== 'undefined' && arg1 instanceof ArrayBuffer) {
                this.data = new buffer_core_arraybuffer.BufferCoreArrayBuffer(arg1);
                this.length = arg1.byteLength;
            } else if (arg1 instanceof Buffer) {
                var argBuff = arg1;
                this.data = new PreferredBufferCore(arg1.length);
                this.length = arg1.length;
                argBuff.copy(this);
            } else if (Array.isArray(arg1) || (arg1 != null && typeof arg1 === 'object' && typeof arg1[0] === 'number')) {
                this.data = new PreferredBufferCore(arg1.length);
                for (i = 0; i < arg1.length; i++) {
                    this.data.writeUInt8(i, arg1[i]);
                }
                this.length = arg1.length;
            } else if (typeof arg1 === 'string') {
                this.length = Buffer.byteLength(arg1, arg2);
                this.data = new PreferredBufferCore(this.length);
                this.write(arg1, 0, this.length, arg2);
            } else {
                throw new Error("Invalid argument to Buffer constructor: " + arg1);
            }
        }
        Buffer.prototype.getBufferCore = function () {
            return this.data;
        };

        Buffer.prototype.getOffset = function () {
            return this.offset;
        };

        Buffer.prototype.set = function (index, value) {
            if (value < 0) {
                return this.writeInt8(value, index);
            } else {
                return this.writeUInt8(value, index);
            }
        };

        Buffer.prototype.get = function (index) {
            return this.readUInt8(index);
        };

        Buffer.prototype.write = function (str, offset, length, encoding) {
            if (typeof offset === "undefined") { offset = 0; }
            if (typeof length === "undefined") { length = this.length; }
            if (typeof encoding === "undefined") { encoding = 'utf8'; }
            if (typeof offset === 'string') {
                encoding = "" + offset;
                offset = 0;
                length = this.length;
            } else if (typeof length === 'string') {
                encoding = "" + length;
                length = this.length;
            }

            if (offset >= this.length) {
                return 0;
            }
            var strUtil = string_util.FindUtil(encoding);

            length = length + offset > this.length ? this.length - offset : length;
            offset += this.offset;
            return strUtil.str2byte(str, offset === 0 && length === this.length ? this : new Buffer(this.data, offset, length + offset));
        };

        Buffer.prototype.toString = function (encoding, start, end) {
            if (typeof encoding === "undefined") { encoding = 'utf8'; }
            if (typeof start === "undefined") { start = 0; }
            if (typeof end === "undefined") { end = this.length; }
            if (!(start <= end)) {
                throw new Error("Invalid start/end positions: " + start + " - " + end);
            }
            if (start === end) {
                return '';
            }
            if (end > this.length) {
                end = this.length;
            }
            var strUtil = string_util.FindUtil(encoding);

            return strUtil.byte2str(start === 0 && end === this.length ? this : new Buffer(this.data, start + this.offset, end + this.offset));
        };

        Buffer.prototype.toJSON = function () {
            var len = this.length;
            var byteArr = new Array(len);
            for (var i = 0; i < len; i++) {
                byteArr[i] = this.readUInt8(i);
            }
            return {
                type: 'Buffer',
                data: byteArr
            };
        };

        Buffer.prototype.copy = function (target, targetStart, sourceStart, sourceEnd) {
            if (typeof targetStart === "undefined") { targetStart = 0; }
            if (typeof sourceStart === "undefined") { sourceStart = 0; }
            if (typeof sourceEnd === "undefined") { sourceEnd = this.length; }
            targetStart = targetStart < 0 ? 0 : targetStart;
            sourceStart = sourceStart < 0 ? 0 : sourceStart;

            if (sourceEnd < sourceStart) {
                throw new RangeError('sourceEnd < sourceStart');
            }
            if (sourceEnd === sourceStart) {
                return 0;
            }
            if (targetStart >= target.length) {
                throw new RangeError('targetStart out of bounds');
            }
            if (sourceStart >= this.length) {
                throw new RangeError('sourceStart out of bounds');
            }
            if (sourceEnd > this.length) {
                throw new RangeError('sourceEnd out of bounds');
            }
            var bytesCopied = Math.min(sourceEnd - sourceStart, target.length - targetStart, this.length - sourceStart);

            for (var i = 0; i < bytesCopied; i++) {
                target.writeUInt8(this.readUInt8(sourceStart + i), targetStart + i);
            }
            return bytesCopied;
        };

        Buffer.prototype.slice = function (start, end) {
            if (typeof start === "undefined") { start = 0; }
            if (typeof end === "undefined") { end = this.length; }
            if (start < 0) {
                start += this.length;
                if (start < 0) {
                    start = 0;
                }
            }
            if (end < 0) {
                end += this.length;
                if (end < 0) {
                    end = 0;
                }
            }
            if (end > this.length) {
                end = this.length;
            }
            if (start > end) {
                start = end;
            }

            if (start < 0 || end < 0 || start >= this.length || end > this.length) {
                throw new Error("Invalid slice indices.");
            }

            return new Buffer(this.data, start + this.offset, end + this.offset);
        };

        Buffer.prototype.sliceCopy = function (start, end) {
            if (typeof start === "undefined") { start = 0; }
            if (typeof end === "undefined") { end = this.length; }
            if (start < 0) {
                start += this.length;
                if (start < 0) {
                    start = 0;
                }
            }
            if (end < 0) {
                end += this.length;
                if (end < 0) {
                    end = 0;
                }
            }
            if (end > this.length) {
                end = this.length;
            }
            if (start > end) {
                start = end;
            }

            if (start < 0 || end < 0 || start >= this.length || end > this.length) {
                throw new Error("Invalid slice indices.");
            }

            return new Buffer(this.data.copy(start + this.offset, end + this.offset));
        };

        Buffer.prototype.fill = function (value, offset, end) {
            if (typeof offset === "undefined") { offset = 0; }
            if (typeof end === "undefined") { end = this.length; }
            var i;
            var valType = typeof value;
            switch (valType) {
                case "string":
                    value = value.charCodeAt(0) & 0xFF;
                    break;
                case "number":
                    break;
                default:
                    throw new Error('Invalid argument to fill.');
            }
            offset += this.offset;
            end += this.offset;
            this.data.fill(value, offset, end);
        };

        Buffer.prototype.readUInt8 = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readUInt8(offset);
        };

        Buffer.prototype.readUInt16LE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readUInt16LE(offset);
        };

        Buffer.prototype.readUInt16BE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readUInt16BE(offset);
        };

        Buffer.prototype.readUInt32LE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readUInt32LE(offset);
        };

        Buffer.prototype.readUInt32BE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readUInt32BE(offset);
        };

        Buffer.prototype.readInt8 = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readInt8(offset);
        };

        Buffer.prototype.readInt16LE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readInt16LE(offset);
        };

        Buffer.prototype.readInt16BE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readInt16BE(offset);
        };

        Buffer.prototype.readInt32LE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readInt32LE(offset);
        };

        Buffer.prototype.readInt32BE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readInt32BE(offset);
        };

        Buffer.prototype.readFloatLE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readFloatLE(offset);
        };

        Buffer.prototype.readFloatBE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readFloatBE(offset);
        };

        Buffer.prototype.readDoubleLE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readDoubleLE(offset);
        };

        Buffer.prototype.readDoubleBE = function (offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            return this.data.readDoubleBE(offset);
        };

        Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeUInt8(offset, value);
        };

        Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeUInt16LE(offset, value);
        };

        Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeUInt16BE(offset, value);
        };

        Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeUInt32LE(offset, value);
        };

        Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeUInt32BE(offset, value);
        };

        Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeInt8(offset, value);
        };

        Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeInt16LE(offset, value);
        };

        Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeInt16BE(offset, value);
        };

        Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeInt32LE(offset, value);
        };

        Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeInt32BE(offset, value);
        };

        Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeFloatLE(offset, value);
        };

        Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeFloatBE(offset, value);
        };

        Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeDoubleLE(offset, value);
        };

        Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
            if (typeof noAssert === "undefined") { noAssert = false; }
            offset += this.offset;
            this.data.writeDoubleBE(offset, value);
        };

        Buffer.isEncoding = function (enc) {
            try  {
                string_util.FindUtil(enc);
            } catch (e) {
                return false;
            }
            return true;
        };

        Buffer.isBuffer = function (obj) {
            return obj instanceof Buffer;
        };

        Buffer.byteLength = function (str, encoding) {
            if (typeof encoding === "undefined") { encoding = 'utf8'; }
            var strUtil = string_util.FindUtil(encoding);
            return strUtil.byteLength(str);
        };

        Buffer.concat = function (list, totalLength) {
            var item;
            if (list.length === 0 || totalLength === 0) {
                return new Buffer(0);
            } else if (list.length === 1) {
                return list[0];
            } else {
                if (totalLength == null) {
                    totalLength = 0;
                    for (var i = 0; i < list.length; i++) {
                        item = list[i];
                        totalLength += item.length;
                    }
                }
                var buf = new Buffer(totalLength);
                var curPos = 0;
                for (var j = 0; j < list.length; j++) {
                    item = list[j];
                    curPos += item.copy(buf, curPos);
                }
                return buf;
            }
        };
        return Buffer;
    })();
    exports.Buffer = Buffer;

    var _ = Buffer;
});
//# sourceMappingURL=buffer.js.map
;